/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { baseStyles, property } from '@cds/core/internal';
import styles from './visual-checkbox.element.scss';
export class CdsInternalVisualCheckbox extends LitElement {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.indeterminate = false;
        this.selected = false;
    }
    static get styles() {
        return [baseStyles, styles];
    }
    render() {
        return html ` <div class="private-host"></div> `;
    }
}
__decorate([
    property({ type: Boolean, reflect: true })
], CdsInternalVisualCheckbox.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], CdsInternalVisualCheckbox.prototype, "indeterminate", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], CdsInternalVisualCheckbox.prototype, "selected", void 0);
